export const countryData = [
  { name: "Afghanistan", iso: "af", minutes: "40", sms: "Included" },
  { name: "Afghanistan - Cellular", iso: "af", minutes: "45", sms: "Included" },
  { name: "Albania", iso: "al", minutes: "45", sms: "Included" },
  { name: "Albania - Cellular", iso: "al", minutes: "15", sms: "Included" },
  { name: "Algeria", iso: "dz", minutes: "Unlimited", sms: "Included" },
  { name: "Algeria - Cellular", iso: "dz", minutes: "10", sms: "Included" },
  { name: "American Samoa", iso: "as", minutes: "Unlimited", sms: "Included" },
  {
    name: "American Samoa - Cellular",
    iso: "as",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Andorra", iso: "ad", minutes: "Unlimited", sms: "Included" },
  { name: "Andorra - Cellular", iso: "ad", minutes: "30", sms: "Included" },
  { name: "Angola", iso: "ao", minutes: "Unlimited", sms: "Included" },
  { name: "Angola - Cellular", iso: "ao", minutes: "45", sms: "Included" },
  { name: "Anguilla", iso: "ai", minutes: "35", sms: "Included" },
  { name: "Anguilla - Cellular", iso: "ai", minutes: "30", sms: "Included" },
  { name: "Antarctica", iso: "aq", minutes: "5", sms: "Included" },
  { name: "Antigua and Barbuda", iso: "ag", minutes: "25", sms: "Included" },
  {
    name: "Antigua and Barbuda - Cellular",
    iso: "ag",
    minutes: "30",
    sms: "Included",
  },
  { name: "Argentina", iso: "ar", minutes: "Unlimited", sms: "Included" },
  {
    name: "Argentina - Buenos Aires",
    iso: "ar",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Argentina - Cellular",
    iso: "ar",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Armenia", iso: "am", minutes: "50", sms: "Included" },
  { name: "Armenia - Cellular", iso: "am", minutes: "30", sms: "Included" },
  { name: "Armenia - Yerevan", iso: "am", minutes: "40", sms: "Included" },
  { name: "Aruba", iso: "aw", minutes: "Unlimited", sms: "Included" },
  { name: "Aruba - Cellular", iso: "aw", minutes: "30", sms: "Included" },
  { name: "Ascension Island", iso: "sh", minutes: "5", sms: "Included" },
  { name: "Australia", iso: "au", minutes: "Unlimited", sms: "Included" },
  {
    name: "Australia - Cellular",
    iso: "au",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Austria", iso: "at", minutes: "120", sms: "Included" },
  { name: "Austria - Cellular", iso: "at", minutes: "30", sms: "Included" },
  {
    name: "Austria - Cellular - Special",
    iso: "at",
    minutes: "20",
    sms: "Included",
  },
  { name: "Azerbaijan", iso: "az", minutes: "35", sms: "Included" },
  { name: "Azerbaijan - Cellular", iso: "az", minutes: "20", sms: "Included" },
  { name: "Bahamas", iso: "bs", minutes: "30", sms: "Included" },
  { name: "Bahamas - Cellular", iso: "bs", minutes: "30", sms: "Included" },
  { name: "Bahrain", iso: "bh", minutes: "60", sms: "Included" },
  { name: "Bahrain - Cellular", iso: "bh", minutes: "60", sms: "Included" },
  { name: "Bangladesh", iso: "bd", minutes: "Unlimited", sms: "Included" },
  {
    name: "Bangladesh - Cellular",
    iso: "bd",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Barbados", iso: "bb", minutes: "40", sms: "Included" },
  { name: "Barbados - Cellular", iso: "bb", minutes: "30", sms: "Included" },
  { name: "Belarus", iso: "by", minutes: "20", sms: "Included" },
  { name: "Belarus - Cellular", iso: "by", minutes: "20", sms: "Included" },
  { name: "Belgium", iso: "be", minutes: "Unlimited", sms: "Included" },
  { name: "Belgium - Cellular", iso: "be", minutes: "45", sms: "Included" },
  {
    name: "Belgium - Cellular - Other",
    iso: "be",
    minutes: "20",
    sms: "Included",
  },
  { name: "Belize", iso: "bz", minutes: "30", sms: "Included" },
  { name: "Belize - Cellular", iso: "bz", minutes: "30", sms: "Included" },
  { name: "Benin", iso: "bj", minutes: "25", sms: "Included" },
  { name: "Benin - Cellular", iso: "bj", minutes: "20", sms: "Included" },
  { name: "Bermuda", iso: "bm", minutes: "Unlimited", sms: "Included" },
  {
    name: "Bermuda - Cellular",
    iso: "bm",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Bhutan", iso: "bt", minutes: "Unlimited", sms: "Included" },
  {
    name: "Bhutan - Cellular",
    iso: "bt",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Bolivia", iso: "bo", minutes: "50", sms: "Included" },
  { name: "Bolivia - Cellular", iso: "bo", minutes: "35", sms: "Included" },
  { name: "Bolivia - Cochabamba", iso: "bo", minutes: "70", sms: "Included" },
  { name: "Bolivia - Equal Access", iso: "bo", minutes: "70", sms: "Included" },
  { name: "Bolivia - La Paz", iso: "bo", minutes: "80", sms: "Included" },
  { name: "Bolivia - Rural", iso: "bo", minutes: "35", sms: "Included" },
  { name: "Bolivia - Santa Cruz", iso: "bo", minutes: "70", sms: "Included" },
  { name: "Bosnia and Herzegovina", iso: "ba", minutes: "45", sms: "Included" },
  {
    name: "Bosnia and Herzegovina - Cellular",
    iso: "ba",
    minutes: "15",
    sms: "Included",
  },
  { name: "Botswana", iso: "bw", minutes: "40", sms: "Included" },
  { name: "Botswana - Cellular", iso: "bw", minutes: "30", sms: "Included" },
  { name: "Brazil", iso: "br", minutes: "Unlimited", sms: "Included" },
  {
    name: "Brazil - Cellular",
    iso: "br",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Brazil - Rio de Janeiro",
    iso: "br",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Brazil - Sao Paulo",
    iso: "br",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "British Virgin Islands", iso: "vg", minutes: "30", sms: "Included" },
  {
    name: "British Virgin Islands - Cellular",
    iso: "vg",
    minutes: "30",
    sms: "Included",
  },
  { name: "Brunei", iso: "bn", minutes: "35", sms: "Included" },
  {
    name: "Brunei - Cellular",
    iso: "bn",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Bulgaria", iso: "bg", minutes: "Unlimited", sms: "Included" },
  { name: "Bulgaria - Cellular", iso: "bg", minutes: "20", sms: "Included" },
  { name: "Burkina Faso", iso: "bf", minutes: "20", sms: "Included" },
  {
    name: "Burkina Faso - Cellular - Celtel",
    iso: "bf",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Burkina Faso - Cellular - Telecel",
    iso: "bf",
    minutes: "30",
    sms: "Included",
  },
  {
    name: "Burkina Faso - Cellular - Telmob",
    iso: "bf",
    minutes: "20",
    sms: "Included",
  },
  { name: "Burundi", iso: "bi", minutes: "20", sms: "Included" },
  { name: "Burundi - Cellular", iso: "bi", minutes: "15", sms: "Included" },
  { name: "Cambodia", iso: "kh", minutes: "Unlimited", sms: "Included" },
  {
    name: "Cambodia - Cellular",
    iso: "kh",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Cameroon", iso: "cm", minutes: "75", sms: "Included" },
  {
    name: "Cameroon - Cellular - MTN",
    iso: "cm",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Cameroon - Cellular - Orange",
    iso: "cm",
    minutes: "20",
    sms: "Included",
  },
  { name: "Canada", iso: "ca", minutes: "Unlimited", sms: "Included" },
  {
    name: "Canada - Northern Territories",
    iso: "ca",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Cape Verde", iso: "cv", minutes: "50", sms: "Included" },
  { name: "Cape Verde - Cellular", iso: "cv", minutes: "25", sms: "Included" },
  { name: "Cayman Islands", iso: "ky", minutes: "Unlimited", sms: "Included" },
  {
    name: "Cayman Islands - Cellular",
    iso: "ky",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Central African Republic",
    iso: "cf",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Central African Republic - Cellular",
    iso: "cf",
    minutes: "10",
    sms: "Included",
  },
  { name: "Chad", iso: "td", minutes: "10", sms: "Included" },
  { name: "Chad - Cellular", iso: "td", minutes: "15", sms: "Included" },
  { name: "Chile", iso: "cl", minutes: "Unlimited", sms: "Included" },
  {
    name: "Chile - Cellular",
    iso: "cl",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Chile - Rural", iso: "cl", minutes: "Unlimited", sms: "Included" },
  {
    name: "Chile - Santiago",
    iso: "cl",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "China", iso: "cn", minutes: "Unlimited", sms: "Included" },
  {
    name: "China - Cellular",
    iso: "cn",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Colombia", iso: "co", minutes: "Unlimited", sms: "Included" },
  {
    name: "Colombia - Armenia",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Barranquilla",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Bogota",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Bucaramanga",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Colombia - Cali", iso: "co", minutes: "Unlimited", sms: "Included" },
  {
    name: "Colombia - Cartagena",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Cellular",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Cellular - Comcel",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Manizales",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Medellin",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Pereira",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Colombia - Rural",
    iso: "co",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Comoros", iso: "km", minutes: "20", sms: "Included" },
  { name: "Comoros - Cellular", iso: "km", minutes: "10", sms: "Included" },
  { name: "Congo", iso: "cg", minutes: "20", sms: "Included" },
  { name: "Congo - Cellular", iso: "cg", minutes: "15", sms: "Included" },
  { name: "Cook Islands", iso: "ck", minutes: "5", sms: "Included" },
  { name: "Costa Rica", iso: "cr", minutes: "Unlimited", sms: "Included" },
  {
    name: "Costa Rica - Cellular",
    iso: "cr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Croatia", iso: "hr", minutes: "Unlimited", sms: "Included" },
  { name: "Croatia - Cellular", iso: "hr", minutes: "60", sms: "Included" },
  { name: "Cuba", iso: "cu", minutes: "10", sms: "Included" },
  { name: "Cuba - Cellular", iso: "cu", minutes: "10", sms: "Included" },
  { name: "Cyprus", iso: "cy", minutes: "60", sms: "Included" },
  { name: "Cyprus - Cellular", iso: "cy", minutes: "40", sms: "Included" },
  { name: "Czech Republic", iso: "cz", minutes: "Unlimited", sms: "Included" },
  {
    name: "Czech Republic - Cellular",
    iso: "cz",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Democratic Republic Congo",
    iso: "cd",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Democratic Republic Congo - Cellular",
    iso: "cd",
    minutes: "15",
    sms: "Included",
  },
  { name: "Denmark", iso: "dk", minutes: "20", sms: "Included" },
  {
    name: "Denmark - Cellular",
    iso: "dk",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Diego Garcia", iso: "io", minutes: "20", sms: "Included" },
  { name: "Djibouti", iso: "dj", minutes: "20", sms: "Included" },
  { name: "Djibouti - Cellular", iso: "dj", minutes: "20", sms: "Included" },
  { name: "Dominica", iso: "dm", minutes: "40", sms: "Included" },
  { name: "Dominica - Cellular", iso: "dm", minutes: "35", sms: "Included" },
  {
    name: "Dominican Republic",
    iso: "do",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Dominican Republic - Cellular",
    iso: "do",
    minutes: "70",
    sms: "Included",
  },
  { name: "East Timor", iso: "tl", minutes: "20", sms: "Included" },
  { name: "Ecuador", iso: "ec", minutes: "60", sms: "Included" },
  {
    name: "Ecuador - Cellular - Alegro",
    iso: "ec",
    minutes: "30",
    sms: "Included",
  },
  {
    name: "Ecuador - Cellular - Movistar",
    iso: "ec",
    minutes: "50",
    sms: "Included",
  },
  {
    name: "Ecuador - Cellular - Claro",
    iso: "ec",
    minutes: "40",
    sms: "Included",
  },
  { name: "Egypt", iso: "eg", minutes: "70", sms: "Included" },
  {
    name: "Egypt - Cellular - Etisalat",
    iso: "eg",
    minutes: "120",
    sms: "Included",
  },
  {
    name: "Egypt - Cellular - Other",
    iso: "eg",
    minutes: "60",
    sms: "Included",
  },
  { name: "El Salvador", iso: "sv", minutes: "70", sms: "Included" },
  {
    name: "El Salvador - Cellular - CTE",
    iso: "sv",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "El Salvador - Cellular - Digicell",
    iso: "sv",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "El Salvador - Cellular - Other",
    iso: "sv",
    minutes: "50",
    sms: "Included",
  },
  {
    name: "El Salvador - Cellular - Telefonica",
    iso: "sv",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "El Salvador - Cellular - Tmovil",
    iso: "sv",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "El Salvador - CTE S.A.",
    iso: "sv",
    minutes: "100",
    sms: "Included",
  },
  {
    name: "El Salvador - Telefonica",
    iso: "sv",
    minutes: "70",
    sms: "Included",
  },
  { name: "Equatorial Guinea", iso: "gq", minutes: "20", sms: "Included" },
  {
    name: "Equatorial Guinea - Cellular",
    iso: "gq",
    minutes: "15",
    sms: "Included",
  },
  { name: "Eritrea", iso: "er", minutes: "30", sms: "Included" },
  { name: "Eritrea - Cellular", iso: "er", minutes: "30", sms: "Included" },
  { name: "Estonia", iso: "ee", minutes: "Unlimited", sms: "Included" },
  { name: "Estonia - Cellular", iso: "ee", minutes: "20", sms: "Included" },
  { name: "Ethiopia", iso: "et", minutes: "30", sms: "Included" },
  { name: "Ethiopia - Addis Ababa", iso: "et", minutes: "30", sms: "Included" },
  {
    name: "Ethiopia - Addis Ababa (Cellular)",
    iso: "et",
    minutes: "35",
    sms: "Included",
  },
  { name: "Ethiopia - Cellular", iso: "et", minutes: "40", sms: "Included" },
  { name: "Falkland Islands", iso: "fk", minutes: "10", sms: "Included" },
  { name: "Faroe Islands", iso: "fo", minutes: "Unlimited", sms: "Included" },
  {
    name: "Faroe Islands - Cellular",
    iso: "fo",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Fiji Islands", iso: "fj", minutes: "25", sms: "Included" },
  {
    name: "Fiji Islands - Cellular",
    iso: "fj",
    minutes: "25",
    sms: "Included",
  },
  { name: "Finland", iso: "fi", minutes: "80", sms: "Included" },
  {
    name: "Finland - Cellular",
    iso: "fi",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "France", iso: "fr", minutes: "Unlimited", sms: "Included" },
  {
    name: "France - Cellular",
    iso: "fr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "French Guiana", iso: "gf", minutes: "Unlimited", sms: "Included" },
  {
    name: "French Guiana - Cellular",
    iso: "gf",
    minutes: "70",
    sms: "Included",
  },
  { name: "French Polynesia", iso: "pf", minutes: "40", sms: "Included" },
  {
    name: "French Polynesia - Cellular",
    iso: "pf",
    minutes: "25",
    sms: "Included",
  },
  { name: "Gabon", iso: "ga", minutes: "20", sms: "Included" },
  { name: "Gabon - Cellular", iso: "ga", minutes: "15", sms: "Included" },
  { name: "Gambia", iso: "gm", minutes: "15", sms: "Included" },
  { name: "Gambia - Cellular", iso: "gm", minutes: "15", sms: "Included" },
  { name: "Georgia", iso: "ge", minutes: "45", sms: "Included" },
  { name: "Georgia - Cellular", iso: "ge", minutes: "25", sms: "Included" },
  { name: "Germany", iso: "de", minutes: "Unlimited", sms: "Included" },
  {
    name: "Germany - Cellular",
    iso: "de",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Germany - Cellular - E Plus",
    iso: "de",
    minutes: "20",
    sms: "Included",
  },
  { name: "Ghana", iso: "gh", minutes: "25", sms: "Included" },
  { name: "Ghana - Cellular - MTN", iso: "gh", minutes: "35", sms: "Included" },
  {
    name: "Ghana - Cellular - Other",
    iso: "gh",
    minutes: "30",
    sms: "Included",
  },
  {
    name: "Ghana - Cellular - Vodafone",
    iso: "gh",
    minutes: "30",
    sms: "Included",
  },
  { name: "Gibraltar", iso: "gi", minutes: "Unlimited", sms: "Included" },
  { name: "Gibraltar - Cellular", iso: "gi", minutes: "50", sms: "Included" },
  { name: "Greece", iso: "gr", minutes: "Unlimited", sms: "Included" },
  {
    name: "Greece - Cellular",
    iso: "gr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Greenland", iso: "gl", minutes: "145", sms: "Included" },
  { name: "Grenada", iso: "gd", minutes: "70", sms: "Included" },
  { name: "Grenada - Cellular", iso: "gd", minutes: "40", sms: "Included" },
  { name: "Guadeloupe", iso: "gp", minutes: "Unlimited", sms: "Included" },
  { name: "Guadeloupe - Cellular", iso: "gp", minutes: "20", sms: "Included" },
  { name: "Guam", iso: "gu", minutes: "Unlimited", sms: "Included" },
  { name: "Guam - Cellular", iso: "gu", minutes: "Unlimited", sms: "Included" },
  { name: "Guantanamo Bay", iso: "cu", minutes: "10", sms: "Included" },
  { name: "Guatemala", iso: "gt", minutes: "70", sms: "Included" },
  {
    name: "Guatemala - Cellular - Comcel",
    iso: "gt",
    minutes: "45",
    sms: "Included",
  },
  {
    name: "Guatemala - Cellular - Sercom/Claro",
    iso: "gt",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "Guatemala - Cellular - Telefonica",
    iso: "gt",
    minutes: "50",
    sms: "Included",
  },
  { name: "Guinea", iso: "gn", minutes: "15", sms: "Included" },
  { name: "Guinea - Bissau", iso: "gw", minutes: "15", sms: "Included" },
  {
    name: "Guinea - Cellular - Areeba",
    iso: "gn",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Guinea - Cellular - Cellcom",
    iso: "gn",
    minutes: "15",
    sms: "Included",
  },
  {
    name: "Guinea - Cellular - Orange",
    iso: "gn",
    minutes: "15",
    sms: "Included",
  },
  { name: "Guyana", iso: "gy", minutes: "30", sms: "Included" },
  {
    name: "Guyana - Cellular - Digicel",
    iso: "gy",
    minutes: "35",
    sms: "Included",
  },
  {
    name: "Guyana - Cellular - Other",
    iso: "gy",
    minutes: "30",
    sms: "Included",
  },
  { name: "Haiti", iso: "ht", minutes: "35", sms: "Included" },
  {
    name: "Haiti - Cellular - Digicel",
    iso: "ht",
    minutes: "25",
    sms: "Included",
  },
  {
    name: "Haiti - Cellular - Other",
    iso: "ht",
    minutes: "50",
    sms: "Included",
  },
  { name: "Honduras", iso: "hn", minutes: "60", sms: "Included" },
  {
    name: "Honduras - Cellular - Celtel",
    iso: "hn",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Honduras - Cellular - Digicel",
    iso: "hn",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Honduras - Cellular - Hondutel",
    iso: "hn",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "Honduras - Cellular - Megatel",
    iso: "hn",
    minutes: "40",
    sms: "Included",
  },
  { name: "Hong Kong", iso: "hk", minutes: "Unlimited", sms: "Included" },
  {
    name: "Hong Kong - Cellular",
    iso: "hk",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Hungary", iso: "hu", minutes: "Unlimited", sms: "Included" },
  {
    name: "Hungary - Cellular",
    iso: "hu",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Iceland", iso: "is", minutes: "Unlimited", sms: "Included" },
  {
    name: "Iceland - Cellular",
    iso: "is",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "India", iso: "in", minutes: "Unlimited", sms: "Included" },
  {
    name: "India - Cellular",
    iso: "in",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Indonesia", iso: "id", minutes: "Unlimited", sms: "Included" },
  {
    name: "Indonesia - Cellular",
    iso: "id",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Indonesia - Jakarta",
    iso: "id",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Indonesia - Surabaya",
    iso: "id",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Iran", iso: "ir", minutes: "40", sms: "Included" },
  { name: "Iran - Cellular", iso: "ir", minutes: "35", sms: "Included" },
  { name: "Iran - Tehran", iso: "ir", minutes: "40", sms: "Included" },
  { name: "Iraq", iso: "iq", minutes: "30", sms: "Included" },
  { name: "Iraq - Baghdad", iso: "iq", minutes: "20", sms: "Included" },
  { name: "Iraq - Cellular", iso: "iq", minutes: "35", sms: "Included" },
  { name: "Ireland", iso: "ie", minutes: "Unlimited", sms: "Included" },
  {
    name: "Ireland - Cellular",
    iso: "ie",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Israel", iso: "il", minutes: "Unlimited", sms: "Included" },
  { name: "Israel - Cellular", iso: "il", minutes: "80", sms: "Included" },
  {
    name: "Israel - Palestine Authority",
    iso: "ps",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Israel - Palestine Authority - Cellular",
    iso: "ps",
    minutes: "30",
    sms: "Included",
  },
  { name: "Italy", iso: "it", minutes: "Unlimited", sms: "Included" },
  {
    name: "Italy - Cellular",
    iso: "it",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Ivory Coast", iso: "ci", minutes: "20", sms: "Included" },
  {
    name: "Ivory Coast - Cellular - Moov",
    iso: "ci",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Ivory Coast - Cellular - MTN",
    iso: "ci",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Ivory Coast - Cellular - Orange",
    iso: "ci",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Ivory Coast - Cellular - Other",
    iso: "ci",
    minutes: "20",
    sms: "Included",
  },
  { name: "Jamaica", iso: "jm", minutes: "40", sms: "Included" },
  {
    name: "Jamaica - Cellular - C&W",
    iso: "jm",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Jamaica - Cellular - Digicel",
    iso: "jm",
    minutes: "40",
    sms: "Included",
  },
  { name: "Japan", iso: "jp", minutes: "Unlimited", sms: "Included" },
  {
    name: "Japan - Cellular",
    iso: "jp",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Jordan", iso: "jo", minutes: "45", sms: "Included" },
  { name: "Jordan - Cellular", iso: "jo", minutes: "40", sms: "Included" },
  { name: "Kazakhstan", iso: "kz", minutes: "Unlimited", sms: "Included" },
  { name: "Kazakhstan - Cellular", iso: "kz", minutes: "40", sms: "Included" },
  { name: "Kenya", iso: "ke", minutes: "40", sms: "Included" },
  {
    name: "Kenya - Cellular - Celtel",
    iso: "ke",
    minutes: "35",
    sms: "Included",
  },
  {
    name: "Kenya - Cellular - Orange",
    iso: "ke",
    minutes: "35",
    sms: "Included",
  },
  {
    name: "Kenya - Cellular - Other",
    iso: "ke",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Kenya - Cellular - Safaricom",
    iso: "ke",
    minutes: "100",
    sms: "Included",
  },
  { name: "Kiribati", iso: "ki", minutes: "10", sms: "Included" },
  { name: "Kosovo", iso: "xk", minutes: "20", sms: "Included" },
  { name: "Kosovo - Cellular", iso: "xk", minutes: "15", sms: "Included" },
  { name: "Kuwait", iso: "kw", minutes: "Unlimited", sms: "Included" },
  {
    name: "Kuwait - Cellular",
    iso: "kw",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Kyrgyzstan", iso: "kg", minutes: "70", sms: "Included" },
  { name: "Kyrgyzstan - Cellular", iso: "kg", minutes: "40", sms: "Included" },
  { name: "Laos", iso: "la", minutes: "Unlimited", sms: "Included" },
  { name: "Laos - Cellular", iso: "la", minutes: "85", sms: "Included" },
  { name: "Latvia", iso: "lv", minutes: "30", sms: "Included" },
  { name: "Latvia - Cellular", iso: "lv", minutes: "20", sms: "Included" },
  { name: "Latvia - Olo", iso: "lv", minutes: "20", sms: "Included" },
  { name: "Lebanon", iso: "lb", minutes: "85", sms: "Included" },
  { name: "Lebanon - Cellular", iso: "lb", minutes: "40", sms: "Included" },
  { name: "Lesotho", iso: "ls", minutes: "15", sms: "Included" },
  { name: "Lesotho - Cellular", iso: "ls", minutes: "10", sms: "Included" },
  { name: "Liberia", iso: "lr", minutes: "20", sms: "Included" },
  {
    name: "Liberia - Cellular - Cellcom",
    iso: "lr",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Liberia - Cellular - Comium",
    iso: "lr",
    minutes: "15",
    sms: "Included",
  },
  {
    name: "Liberia - Cellular - Libercell",
    iso: "lr",
    minutes: "15",
    sms: "Included",
  },
  {
    name: "Liberia - Cellular - Lonestar",
    iso: "lr",
    minutes: "20",
    sms: "Included",
  },
  { name: "Libya", iso: "ly", minutes: "30", sms: "Included" },
  { name: "Libya - Cellular", iso: "ly", minutes: "25", sms: "Included" },
  {
    name: "Libya - Cellular - Al Hurra",
    iso: "ly",
    minutes: "20",
    sms: "Included",
  },
  { name: "Liechtenstein", iso: "li", minutes: "Unlimited", sms: "Included" },
  {
    name: "Liechtenstein - Cellular",
    iso: "li",
    minutes: "120",
    sms: "Included",
  },
  {
    name: "Liechtenstein - Premium Services",
    iso: "li",
    minutes: "135",
    sms: "Included",
  },
  { name: "Lithuania", iso: "lt", minutes: "50", sms: "Included" },
  { name: "Lithuania - Cellular", iso: "lt", minutes: "20", sms: "Included" },
  {
    name: "Lithuania - Personal Numbering",
    iso: "lt",
    minutes: "20",
    sms: "Included",
  },
  { name: "Luxembourg", iso: "lu", minutes: "40", sms: "Included" },
  { name: "Luxembourg - Cellular", iso: "lu", minutes: "40", sms: "Included" },
  { name: "Macao", iso: "mo", minutes: "60", sms: "Included" },
  { name: "Macao - Cellular", iso: "mo", minutes: "60", sms: "Included" },
  { name: "Macedonia", iso: "mk", minutes: "50", sms: "Included" },
  { name: "Macedonia - Cellular", iso: "mk", minutes: "20", sms: "Included" },
  { name: "Madagascar", iso: "mg", minutes: "10", sms: "Included" },
  { name: "Madagascar - Cellular", iso: "mg", minutes: "10", sms: "Included" },
  { name: "Malawi", iso: "mw", minutes: "15", sms: "Included" },
  { name: "Malawi - Cellular", iso: "mw", minutes: "15", sms: "Included" },
  { name: "Malaysia", iso: "my", minutes: "Unlimited", sms: "Included" },
  {
    name: "Malaysia - Cellular",
    iso: "my",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Maldives", iso: "mv", minutes: "10", sms: "Included" },
  { name: "Mali", iso: "ml", minutes: "15", sms: "Included" },
  { name: "Mali - Cellular", iso: "ml", minutes: "20", sms: "Included" },
  { name: "Malta", iso: "mt", minutes: "45", sms: "Included" },
  { name: "Malta - Cellular", iso: "mt", minutes: "15", sms: "Included" },
  { name: "Mariana Islands", iso: "mp", minutes: "Unlimited", sms: "Included" },
  {
    name: "Mariana Islands - Cellular",
    iso: "mp",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Marshall Islands", iso: "mh", minutes: "30", sms: "Included" },
  {
    name: "Marshall Islands - Cellular",
    iso: "mh",
    minutes: "30",
    sms: "Included",
  },
  { name: "Martinique", iso: "mq", minutes: "Unlimited", sms: "Included" },
  { name: "Martinique - Cellular", iso: "mq", minutes: "20", sms: "Included" },
  { name: "Mauritania", iso: "mr", minutes: "20", sms: "Included" },
  { name: "Mauritania - Cellular", iso: "mr", minutes: "15", sms: "Included" },
  { name: "Mauritius", iso: "mu", minutes: "Unlimited", sms: "Included" },
  {
    name: "Mexico - Cellular - Movistar",
    iso: "mx",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Mexico - Offnet", iso: "mx", minutes: "Unlimited", sms: "Included" },
  { name: "Mexico - Onnet", iso: "mx", minutes: "Unlimited", sms: "Included" },
  { name: "Mexico - ROC", iso: "mx", minutes: "Unlimited", sms: "Included" },
  {
    name: "Mexico - Satellite",
    iso: "mx",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Mexico - Triangle",
    iso: "mx",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Micronesia", iso: "fm", minutes: "10", sms: "Included" },
  { name: "Micronesia - Cellular", iso: "fm", minutes: "10", sms: "Included" },
  { name: "Moldova", iso: "md", minutes: "30", sms: "Included" },
  { name: "Moldova - Cellular", iso: "md", minutes: "30", sms: "Included" },
  { name: "Monaco", iso: "mc", minutes: "Unlimited", sms: "Included" },
  { name: "Monaco - Cellular", iso: "mc", minutes: "15", sms: "Included" },
  { name: "Mongolia", iso: "mn", minutes: "Unlimited", sms: "Included" },
  {
    name: "Mongolia - Cellular",
    iso: "mn",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Montenegro", iso: "me", minutes: "35", sms: "Included" },
  { name: "Montenegro - Cellular", iso: "me", minutes: "10", sms: "Included" },
  { name: "Montserrat", iso: "ms", minutes: "30", sms: "Included" },
  { name: "Montserrat - Cellular", iso: "ms", minutes: "30", sms: "Included" },
  { name: "Morocco", iso: "ma", minutes: "Unlimited", sms: "Included" },
  { name: "Morocco - Cellular", iso: "ma", minutes: "10", sms: "Included" },
  { name: "Morocco - Wana", iso: "ma", minutes: "15", sms: "Included" },
  { name: "Mozambique", iso: "mz", minutes: "35", sms: "Included" },
  { name: "Mozambique - Cellular", iso: "mz", minutes: "20", sms: "Included" },
  { name: "Myanmar", iso: "mm", minutes: "50", sms: "Included" },
  { name: "Myanmar - Cellular", iso: "mm", minutes: "40", sms: "Included" },
  { name: "Namibia", iso: "na", minutes: "Unlimited", sms: "Included" },
  {
    name: "Namibia - Cellular",
    iso: "na",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Nauru", iso: "nr", minutes: "20", sms: "Included" },
  { name: "Nepal", iso: "np", minutes: "45", sms: "Included" },
  { name: "Nepal - Cellular", iso: "np", minutes: "50", sms: "Included" },
  { name: "Nepal - Katmandu", iso: "np", minutes: "45", sms: "Included" },
  { name: "Netherlands", iso: "nl", minutes: "Unlimited", sms: "Included" },
  { name: "Netherlands - Cellular", iso: "nl", minutes: "35", sms: "Included" },
  { name: "Netherlands Antilles", iso: "an", minutes: "35", sms: "Included" },
  {
    name: "Netherlands Antilles - Cellular",
    iso: "an",
    minutes: "45",
    sms: "Included",
  },
  {
    name: "Netherlands Antilles - Curacao",
    iso: "cw",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "New Caledonia", iso: "nc", minutes: "20", sms: "Included" },
  { name: "New Zealand", iso: "nz", minutes: "Unlimited", sms: "Included" },
  {
    name: "New Zealand - Cellular",
    iso: "nz",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "New Zealand - Scott Base",
    iso: "nz",
    minutes: "20",
    sms: "Included",
  },
  { name: "Nicaragua", iso: "ni", minutes: "50", sms: "Included" },
  {
    name: "Nicaragua - Cellular - Claro",
    iso: "ni",
    minutes: "45",
    sms: "Included",
  },
  {
    name: "Nicaragua - Cellular - Movistar",
    iso: "ni",
    minutes: "35",
    sms: "Included",
  },
  { name: "Niger", iso: "ne", minutes: "30", sms: "Included" },
  { name: "Niger - Cellular", iso: "ne", minutes: "30", sms: "Included" },
  { name: "Nigeria", iso: "ng", minutes: "75", sms: "Included" },
  {
    name: "Nigeria - Cellular - Celtel",
    iso: "ng",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "Nigeria - Cellular - Globacom",
    iso: "ng",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "Nigeria - Cellular - MTN",
    iso: "ng",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "Nigeria - Cellular - Other",
    iso: "ng",
    minutes: "70",
    sms: "Included",
  },
  { name: "Nigeria - Lagos", iso: "ng", minutes: "50", sms: "Included" },
  { name: "Niue", iso: "nu", minutes: "20", sms: "Included" },
  { name: "Norfolk Island", iso: "nf", minutes: "20", sms: "Included" },
  { name: "North Korea", iso: "kp", minutes: "5", sms: "Included" },
  { name: "Norway", iso: "no", minutes: "Unlimited", sms: "Included" },
  {
    name: "Norway - Cellular",
    iso: "no",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Oman", iso: "om", minutes: "80", sms: "Included" },
  { name: "Oman - Cellular", iso: "om", minutes: "30", sms: "Included" },
  { name: "Pakistan", iso: "pk", minutes: "Unlimited", sms: "Included" },
  {
    name: "Pakistan - Cellular - Other",
    iso: "pk",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Pakistan - Cellular - Telenor",
    iso: "pk",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Pakistan - Cellular - Warid",
    iso: "pk",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Palau", iso: "pw", minutes: "30", sms: "Included" },
  { name: "Palestine", iso: "ps", minutes: "40", sms: "Included" },
  { name: "Palestine - Cellular", iso: "ps", minutes: "35", sms: "Included" },
  { name: "Panama", iso: "pa", minutes: "Unlimited", sms: "Included" },
  { name: "Panama - Cellular", iso: "pa", minutes: "60", sms: "Included" },
  { name: "Papua New Guinea", iso: "pg", minutes: "10", sms: "Included" },
  { name: "Paraguay", iso: "py", minutes: "Unlimited", sms: "Included" },
  {
    name: "Paraguay - Asuncion",
    iso: "py",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Paraguay - Cellular",
    iso: "py",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Peru", iso: "pe", minutes: "Unlimited", sms: "Included" },
  {
    name: "Peru - Cellular - America Movil",
    iso: "pe",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Peru - Cellular - Nextel",
    iso: "pe",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Peru - Cellular - Other",
    iso: "pe",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Peru - Cellular - Telefonica",
    iso: "pe",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Peru - Lima", iso: "pe", minutes: "Unlimited", sms: "Included" },
  { name: "Peru - Rural", iso: "pe", minutes: "Unlimited", sms: "Included" },
  { name: "Philippines", iso: "ph", minutes: "60", sms: "Included" },
  {
    name: "Philippines - Cellular - Globe",
    iso: "ph",
    minutes: "70",
    sms: "Included",
  },
  {
    name: "Philippines - Cellular - Other",
    iso: "ph",
    minutes: "35",
    sms: "Included",
  },
  {
    name: "Philippines - Cellular - Smart",
    iso: "ph",
    minutes: "60",
    sms: "Included",
  },
  { name: "Philippines - Manila", iso: "ph", minutes: "60", sms: "Included" },
  { name: "Poland", iso: "pl", minutes: "Unlimited", sms: "Included" },
  {
    name: "Poland - Cellular",
    iso: "pl",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Portugal", iso: "pt", minutes: "Unlimited", sms: "Included" },
  { name: "Portugal - Cellular", iso: "pt", minutes: "40", sms: "Included" },
  { name: "Puerto Rico", iso: "pr", minutes: "Unlimited", sms: "Included" },
  {
    name: "Puerto Rico - Cellular",
    iso: "pr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Qatar", iso: "qa", minutes: "40", sms: "Included" },
  { name: "Qatar - Cellular", iso: "qa", minutes: "40", sms: "Included" },
  { name: "Reunion Island", iso: "re", minutes: "190", sms: "Included" },
  {
    name: "Reunion Island - Cellular",
    iso: "re",
    minutes: "10",
    sms: "Included",
  },
  { name: "Romania", iso: "ro", minutes: "Unlimited", sms: "Included" },
  {
    name: "Romania - Cellular",
    iso: "ro",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Russia", iso: "ru", minutes: "Unlimited", sms: "Included" },
  { name: "Russia - Abkhazia", iso: "ru", minutes: "30", sms: "Included" },
  {
    name: "Russia - Cellular - Beeline",
    iso: "ru",
    minutes: "45",
    sms: "Included",
  },
  {
    name: "Russia - Cellular - Megafone",
    iso: "ru",
    minutes: "40",
    sms: "Included",
  },
  {
    name: "Russia - Cellular - MTS",
    iso: "ru",
    minutes: "45",
    sms: "Included",
  },
  {
    name: "Russia - Cellular - Other",
    iso: "ru",
    minutes: "30",
    sms: "Included",
  },
  { name: "Russia - Moscow", iso: "ru", minutes: "75", sms: "Included" },
  {
    name: "Russia - St. Petersburg",
    iso: "ru",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Rwanda", iso: "rw", minutes: "25", sms: "Included" },
  { name: "Rwanda - Cellular", iso: "rw", minutes: "25", sms: "Included" },
  { name: "Samoa", iso: "ws", minutes: "5", sms: "Included" },
  { name: "Samoa - Cellular", iso: "ws", minutes: "5", sms: "Included" },
  { name: "San Marino", iso: "sm", minutes: "Unlimited", sms: "Included" },
  { name: "San Marino - Cellular", iso: "sm", minutes: "40", sms: "Included" },
  { name: "Sao Tome and Principe", iso: "st", minutes: "5", sms: "Included" },
  { name: "Saudi Arabia", iso: "sa", minutes: "60", sms: "Included" },
  {
    name: "Saudi Arabia - Cellular - Other",
    iso: "sa",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "Saudi Arabia - Cellular - STC",
    iso: "sa",
    minutes: "50",
    sms: "Included",
  },
  { name: "Senegal", iso: "sn", minutes: "20", sms: "Included" },
  {
    name: "Senegal - Cellular - Orange",
    iso: "sn",
    minutes: "30",
    sms: "Included",
  },
  {
    name: "Senegal - Cellular - Sudatel",
    iso: "sn",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "Senegal - Cellular - Tigo",
    iso: "sn",
    minutes: "20",
    sms: "Included",
  },
  { name: "Serbia", iso: "rs", minutes: "45", sms: "Included" },
  { name: "Serbia - Cellular", iso: "rs", minutes: "20", sms: "Included" },
  { name: "Serbia - Kosovo", iso: "xk", minutes: "10", sms: "Included" },
  { name: "Seychelles", iso: "sc", minutes: "10", sms: "Included" },
  { name: "Sierra Leone", iso: "sl", minutes: "10", sms: "Included" },
  {
    name: "Sierra Leone - Cellular",
    iso: "sl",
    minutes: "15",
    sms: "Included",
  },
  { name: "Singapore", iso: "sg", minutes: "Unlimited", sms: "Included" },
  {
    name: "Singapore - Cellular",
    iso: "sg",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Slovakia", iso: "sk", minutes: "Unlimited", sms: "Included" },
  { name: "Slovakia - Cellular", iso: "sk", minutes: "60", sms: "Included" },
  { name: "Slovenia", iso: "si", minutes: "40", sms: "Included" },
  { name: "Slovenia - Cellular", iso: "si", minutes: "20", sms: "Included" },
  { name: "Solomon Islands", iso: "sb", minutes: "5", sms: "Included" },
  { name: "Somalia", iso: "so", minutes: "20", sms: "Included" },
  { name: "Somalia - Cellular", iso: "so", minutes: "25", sms: "Included" },
  { name: "South Africa", iso: "za", minutes: "70", sms: "Included" },
  {
    name: "South Africa - Cellular",
    iso: "za",
    minutes: "60",
    sms: "Included",
  },
  {
    name: "South Africa - Cellular - MTN",
    iso: "za",
    minutes: "60",
    sms: "Included",
  },
  { name: "South Korea", iso: "kr", minutes: "Unlimited", sms: "Included" },
  {
    name: "South Korea - Cellular",
    iso: "kr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "South Sudan", iso: "ss", minutes: "20", sms: "Included" },
  { name: "South Sudan - Cellular", iso: "ss", minutes: "15", sms: "Included" },
  { name: "Spain", iso: "es", minutes: "Unlimited", sms: "Included" },
  {
    name: "Spain - Cellular",
    iso: "es",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Spain - Cellular - Special",
    iso: "es",
    minutes: "20",
    sms: "Included",
  },
  { name: "Sri Lanka", iso: "lk", minutes: "50", sms: "Included" },
  { name: "Sri Lanka - Cellular", iso: "lk", minutes: "45", sms: "Included" },
  { name: "St. Helena", iso: "sh", minutes: "20", sms: "Included" },
  { name: "St. Kitts and Nevis", iso: "kn", minutes: "40", sms: "Included" },
  {
    name: "St. Kitts and Nevis - Cellular",
    iso: "kn",
    minutes: "30",
    sms: "Included",
  },
  { name: "St. Lucia", iso: "lc", minutes: "50", sms: "Included" },
  { name: "St. Lucia - Cellular", iso: "lc", minutes: "35", sms: "Included" },
  { name: "St. Maarten", iso: "sx", minutes: "60", sms: "Included" },
  { name: "St. Maarten - Cellular", iso: "sx", minutes: "60", sms: "Included" },
  {
    name: "St. Pierre and Miquelon",
    iso: "pm",
    minutes: "25",
    sms: "Included",
  },
  {
    name: "St. Pierre and Miquelon - Cellular",
    iso: "pm",
    minutes: "20",
    sms: "Included",
  },
  { name: "St. Vincent", iso: "vc", minutes: "45", sms: "Included" },
  { name: "St. Vincent - Cellular", iso: "vc", minutes: "30", sms: "Included" },
  { name: "Sudan", iso: "sd", minutes: "45", sms: "Included" },
  { name: "Sudan - Cellular - MTN", iso: "sd", minutes: "40", sms: "Included" },
  {
    name: "Sudan - Cellular - Sudatel",
    iso: "sd",
    minutes: "35",
    sms: "Included",
  },
  {
    name: "Sudan - Cellular - Zain",
    iso: "sd",
    minutes: "50",
    sms: "Included",
  },
  { name: "Suriname", iso: "sr", minutes: "40", sms: "Included" },
  { name: "Suriname - Cellular", iso: "sr", minutes: "25", sms: "Included" },
  { name: "Swaziland", iso: "sz", minutes: "50", sms: "Included" },
  { name: "Swaziland - Cellular", iso: "sz", minutes: "50", sms: "Included" },
  { name: "Sweden", iso: "se", minutes: "Unlimited", sms: "Included" },
  {
    name: "Sweden - Cellular",
    iso: "se",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Switzerland", iso: "ch", minutes: "Unlimited", sms: "Included" },
  { name: "Switzerland - Cellular", iso: "ch", minutes: "20", sms: "Included" },
  {
    name: "Switzerland - Cellular - Sunrise",
    iso: "ch",
    minutes: "20",
    sms: "Included",
  },
  { name: "Syria", iso: "sy", minutes: "30", sms: "Included" },
  { name: "Syria - Cellular", iso: "sy", minutes: "25", sms: "Included" },
  { name: "Taiwan", iso: "tw", minutes: "Unlimited", sms: "Included" },
  { name: "Taiwan - Cellular", iso: "tw", minutes: "75", sms: "Included" },
  { name: "Tajikistan", iso: "tj", minutes: "20", sms: "Included" },
  { name: "Tajikistan - Cellular", iso: "tj", minutes: "40", sms: "Included" },
  { name: "Tanzania", iso: "tz", minutes: "20", sms: "Included" },
  { name: "Tanzania - Cellular", iso: "tz", minutes: "20", sms: "Included" },
  { name: "Thailand", iso: "th", minutes: "Unlimited", sms: "Included" },
  {
    name: "Thailand - Bangkok",
    iso: "th",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Thailand - Cellular",
    iso: "th",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Togo", iso: "tg", minutes: "25", sms: "Included" },
  { name: "Togo - Cellular", iso: "tg", minutes: "20", sms: "Included" },
  { name: "Tokelau", iso: "tk", minutes: "5", sms: "Included" },
  { name: "Tonga", iso: "to", minutes: "5", sms: "Included" },
  { name: "Tonga - Cellular", iso: "to", minutes: "5", sms: "Included" },
  {
    name: "Trinidad and Tobago",
    iso: "tt",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Trinidad and Tobago - Cellular",
    iso: "tt",
    minutes: "50",
    sms: "Included",
  },
  { name: "Tunisia", iso: "tn", minutes: "10", sms: "Included" },
  { name: "Tunisia - Cellular", iso: "tn", minutes: "10", sms: "Included" },
  { name: "Turkey", iso: "tr", minutes: "Unlimited", sms: "Included" },
  { name: "Turkey - Ankara", iso: "tr", minutes: "Unlimited", sms: "Included" },
  { name: "Turkey - Bursa", iso: "tr", minutes: "Unlimited", sms: "Included" },
  { name: "Turkey - Cellular", iso: "tr", minutes: "40", sms: "Included" },
  {
    name: "Turkey - Istanbul",
    iso: "tr",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Turkmenistan", iso: "tm", minutes: "45", sms: "Included" },
  { name: "Turks and Caicos", iso: "tc", minutes: "35", sms: "Included" },
  {
    name: "Turks and Caicos - Cellular",
    iso: "tc",
    minutes: "30",
    sms: "Included",
  },
  { name: "Tuvalu", iso: "tv", minutes: "5", sms: "Included" },
  { name: "Uganda", iso: "ug", minutes: "20", sms: "Included" },
  { name: "Uganda - Cellular", iso: "ug", minutes: "20", sms: "Included" },
  { name: "Ukraine", iso: "ua", minutes: "50", sms: "Included" },
  { name: "Ukraine - Cellular", iso: "ua", minutes: "30", sms: "Included" },
  { name: "United Arab Emirates", iso: "ae", minutes: "45", sms: "Included" },
  {
    name: "United Arab Emirates - Cellular",
    iso: "ae",
    minutes: "45",
    sms: "Included",
  },
  { name: "United Kingdom", iso: "gb", minutes: "Unlimited", sms: "Included" },
  {
    name: "United Kingdom - Cellular - Hutchison",
    iso: "gb",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - O2",
    iso: "gb",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - Orange",
    iso: "gb",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - Other",
    iso: "gb",
    minutes: "20",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - Special",
    iso: "gb",
    minutes: "30",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - T-Mobile",
    iso: "gb",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "United Kingdom - Cellular - Vodafone",
    iso: "gb",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "United Kingdom - Personal Numbering",
    iso: "gb",
    minutes: "20",
    sms: "Included",
  },
  { name: "Uruguay", iso: "uy", minutes: "Unlimited", sms: "Included" },
  { name: "Uruguay - Cellular", iso: "uy", minutes: "45", sms: "Included" },
  {
    name: "Uruguay - Montevideo",
    iso: "uy",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "US Virgin Islands",
    iso: "vi",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "US Virgin Islands - Cellular",
    iso: "vi",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Uzbekistan", iso: "uz", minutes: "70", sms: "Included" },
  { name: "Uzbekistan - Cellular", iso: "uz", minutes: "90", sms: "Included" },
  { name: "Uzbekistan - Tashkent", iso: "uz", minutes: "85", sms: "Included" },
  { name: "Vanuatu", iso: "vu", minutes: "2", sms: "Included" },
  { name: "Venezuela", iso: "ve", minutes: "Unlimited", sms: "Included" },
  {
    name: "Venezuela - Caracas",
    iso: "ve",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Venezuela - Cellular", iso: "ve", minutes: "125", sms: "Included" },
  { name: "Vietnam", iso: "vn", minutes: "Unlimited", sms: "Included" },
  {
    name: "Vietnam - Cellular",
    iso: "vn",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Vietnam - Ha Noi",
    iso: "vn",
    minutes: "Unlimited",
    sms: "Included",
  },
  {
    name: "Vietnam - Ho Chi Minh",
    iso: "vn",
    minutes: "Unlimited",
    sms: "Included",
  },
  { name: "Wallis and Futuna", iso: "wf", minutes: "20", sms: "Included" },
  { name: "Yemen", iso: "ye", minutes: "50", sms: "Included" },
  { name: "Yemen - Cellular - MTN", iso: "ye", minutes: "50", sms: "Included" },
  {
    name: "Yemen - Cellular - Other",
    iso: "ye",
    minutes: "50",
    sms: "Included",
  },
  {
    name: "Yemen - Cellular - Sabafon",
    iso: "ye",
    minutes: "50",
    sms: "Included",
  },
  { name: "Zambia", iso: "zm", minutes: "15", sms: "Included" },
  { name: "Zambia - Cellular", iso: "zm", minutes: "15", sms: "Included" },
  { name: "Zimbabwe", iso: "zw", minutes: "30", sms: "Included" },
  { name: "Zimbabwe - Cellular", iso: "zw", minutes: "10", sms: "Included" },
];
